// extracted by mini-css-extract-plugin
module.exports = {"root":"RoleSwitcher_root__KMFZ","label":"RoleSwitcher_label_1In5v"};